import { Action } from 'redux';
import { HttpMethod } from 'src/api';
import ActionDTO from 'src/entities/basic-types/ActionDTO';

type DownloadManagementAction =
    | 'create_new_document'
    | 'manage_categories'
    | 'edit_document'
    | 'manage_download'
    | 'delete_download';

type RepairOfferAction = 'popup_create_offer';
type RepairOrderAction = 'popup_finish_repair_order';
type RepairM1 = 'popup_repair';
// fakeActions, only for testing
type InOfficialAction =
    | 'dialog_machine_deployment_details'
    | 'dialog_machine_deployment_edit_appointment'
    | 'dialog_machine_deployment_remove_appointment'
    | 'dialog_machine_deployment_accept_inventory'
    | 'dialog_machine_deployment_edit_preparation'
    | 'dialog_machine_deployment_finish_preparation'
    | 'dialog_machine_deployment_protocol'
    | 'dialog_start_reparatur'
    | 'dialog_finish_reparatur'
    | 'dialog_perfect_machine'
    | 'dialog_repeat_cleaning'
    | 'dialog_finish_cleaning'
    | 'dialog_start_service_drive'
    | 'POST_service_drive'
    | 'dialog_finish_service_drive'
    | 'dialog_create_repair_offer'
    | 'dialog_decision_making';

type MailAction_inofficial =
    | 'edit_mails'
    | 'dialog_add_new_mailscope_to_mailkey'
    | 'delete_mailscope'
    | 'dialog_mailtemplate_preview';

type VideoActions_inofficial =
    | 'show_video_rating'
    | 'edit_video'
    | 'edit_languages'
    | 'add_category'
    | 'delete_category';

type CalendarAction_inofficial =
    | 'edit_participants'
    | 'print_participant_list'
    | 'upload_document'
    | 'show_document'
    | 'edit_event'
    | 'delete_event';

type CalendarTrainingAction_inofficial = 'edit_training' | 'remove_training';
type CalendarLocationAction_inofficial = 'edit_location' | 'remove_location';
type CalendarLanguageAction_inofficial = 'edit_language' | 'remove_language';
type CalendarCommissionModelAction_inofficial = 'edit_commission_model' | 'remove_commission_model';

type ArticleManagementArticle =
    | 'OPEN_POPUP'
    | 'OPEN_SPECIALIZATION_POPUP'
    | 'OPEN_PROPERTIES_POPUP'
    | 'OPEN_CUSTOM_FIELDS_POPUP'
    | 'activate_article_am'
    | 'deactivate_article_am';
type ArticleManagementArticleGroup =
    | 'edit_article_group_country_tax_am'
    | 'edit_article_group_group_rebate_am'
    | 'edit_article_group_am'
    | 'delete_article_group_am';
type ArticleManagementArticleCommissionModel = 'delete_commission_model_am';

export type FilteredOrderAction = '';

export type ActionNew =
    | DownloadManagementAction
    | RepairOfferAction
    | RepairOrderAction
    | RepairM1
    | InOfficialAction
    | MailAction_inofficial
    | VideoActions_inofficial
    | CalendarAction_inofficial
    | CalendarTrainingAction_inofficial
    | CalendarLocationAction_inofficial
    | CalendarLanguageAction_inofficial
    | CalendarCommissionModelAction_inofficial
    | ArticleManagementArticle
    | ArticleManagementArticleGroup
    | ArticleManagementArticleCommissionModel
    | FilteredOrderAction;
export type ActionAdmin = Action & ActionNew;

export default class ActionDTOAdmin extends ActionDTO<Action> {
    public readonly action: ActionAdmin | HttpMethod;

    constructor(json: any) {
        super(json);
        this.action = json.action as ActionAdmin;
    }
}
